export default "__VITE_ASSET__Ct18HHd9__"